import { useNavigate } from 'react-router-dom';
import { useEffect, useCallback } from 'react';

/**
 * Hook to redirect to the default funnel landing page
 * Reads REACT_APP_DEFAULT_FUNNEL_NR from environment variables
 * and redirects to funnel{number}/landing
 * 
 * @param {boolean} autoRedirect - If true, automatically redirects on mount. Default: false
 * @returns {Function} redirectToDefaultFunnel - Function to manually trigger redirect
 */
const useDefaultFunnelRedirect = (autoRedirect = false) => {
	const navigate = useNavigate();

	// Get default funnel number from environment variable
	const defaultFunnelNr = process.env.REACT_APP_DEFAULT_FUNNEL_NR || '15';

	/**
	 * Function to redirect to default funnel landing page
	 */
	const redirectToDefaultFunnel = useCallback(() => {
		navigate(`/${defaultFunnelNr}/landing`, { replace: true });
	}, [navigate, defaultFunnelNr]);

	// Auto-redirect on mount if enabled
	useEffect(() => {
		if (autoRedirect) {
			redirectToDefaultFunnel();
		}
	}, [autoRedirect, redirectToDefaultFunnel]);

	return {
		redirectToDefaultFunnel,
		defaultFunnelNr,
	};
};

export default useDefaultFunnelRedirect;

